import { RefreshCcw, AlertTriangle } from "lucide-react"

export function WebsiteDisabledPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="max-w-md w-full text-center bg-white p-8 rounded-2xl shadow-lg">
        {/* Icon */}
        <div className="flex justify-center mb-4">
          <div className="bg-red-100 p-3 rounded-full">
            <AlertTriangle className="w-8 h-8 text-red-600" />
          </div>
        </div>

        {/* Title */}
        <h1 className="text-xl font-semibold text-gray-800">
          Website Disabled
        </h1>

        {/* Description */}
        <p className="text-sm text-gray-500 mt-2">
          This store is currently not available. Please contact the
          administrator or try again later.
        </p>

        {/* Actions */}
        <div className="mt-6 flex gap-3 justify-center">
          <button
            onClick={() => window.location.reload()}
            className="flex items-center gap-2 px-4 py-2 bg-gray-900 text-white rounded-lg text-sm"
          >
            <RefreshCcw className="w-4 h-4" />
            Retry
          </button>
        </div>
      </div>
    </div>
  )
}
